import { Provider, WorkflowCodeType, WorkflowComponentOutputType, WorkflowComponentParamType } from '../types';
import { WorkflowComponent } from './common/workflowcomponent';
class GetTableByName extends WorkflowComponent {
    constructor() {
        super({
            name: 'native.gettablebyname',
            group: 'Input/Output',
            title: 'Get Table by Name',
            description: 'Load a table as a source in the workflow using its FQN e.g.: mydata.tables.table'
        }, [
            {
                name: 'source',
                type: WorkflowComponentParamType.String,
                title: 'Source table FQN',
                placeholder: 'mydata.tables.mytable',
                validation: '^[a-zA-Z_][a-zA-Z0-9_-]*\\.[a-zA-Z_][a-zA-Z0-9_-]*\\.[a-zA-Z_][a-zA-Z0-9_-]*$'
            }
        ], [
            {
                name: 'out',
                title: 'Table',
                description: 'The output table',
                type: WorkflowComponentOutputType.Table
            }
        ]);
        this.requiresDynamicSQL = true;
    }
    cleanValue(value) {
        return value.replace(/[\(\)'"`]/g, ''); // remove parentheses and quotes if expression
    }
    async getCode({ workflow, params, connection, codeType }) {
        const viewname = connection.getOutputViewName(workflow.id, this.metadata.name, params, 'out', codeType);
        let source = params.source.replace(/[\(\)'"`]/g, '');
        if (codeType !== WorkflowCodeType.StoredProcedure) {
            // variable substitution is done here instead of in a later step, since this requires a particular handling
            // the substitution that will happen later will have no effect.
            const sortedVariables = workflow.variables
                .slice()
                .sort((a, b) => (a.name < b.name ? 1 : b.name < a.name ? -1 : 0));
            for (const variable of sortedVariables) {
                source = source.replace(RegExp(`@${variable.name}`, 'g'), connection.quoteName(variable.value));
            }
        }
        let query = '';
        if (connection.type === Provider.DatabricksRest) {
            query = connection.getCreateTempViewQuery(viewname, `select /*+ REPARTITION(40) */ * from ${connection.quoteName(source.replace(/`/g, ''))}`, codeType);
        }
        else {
            query = connection.getCreateTempViewQuery(viewname, `select * from ${connection.quoteName(source.replace(/`/g, ''))}`, codeType);
        }
        return {
            query,
            outputs: { out: viewname }
        };
    }
    getOutputTables({ params, connection, workflow, codeType }) {
        const viewname = connection.getOutputViewName(workflow.id, this.metadata.name, params, 'out', codeType);
        return { out: viewname };
    }
}
export { GetTableByName };
